/*
 * Created on Mon Nov 19 2018
 *
 * Copyright (c) 2018 - Francisco Giana <gianafrancisco@gmail.com>
 */
import { ArancelesRespuesta } from './../_models/aranceles';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({ providedIn: 'root' })
export class ArancelesService {
    constructor(private http: HttpClient) { }

    getAll() {
        return this.http.get<ArancelesRespuesta>('assets/db/aranceles.json');
    }

}
